import React from 'react';

import { GameContext } from '../../../contexts/game';

export const RecipientSelector: React.FC<{
  selectedRecepient: { code: string; name: string } | undefined;
  setSelectedRecepient: React.Dispatch<
    React.SetStateAction<{ code: string; name: string } | undefined>
  >;
}> = ({ selectedRecepient, setSelectedRecepient }) => {
  const [game] = React.useContext(GameContext);

  const recepients = React.useMemo(() => {
    if (!game.gameState) return [];

    return [
      { code: '0', name: 'Global (All Player)' },
      ...game.gameState.teams.map((t) => ({
        code: t.code ?? '',
        name: t.name ?? ''
      }))
    ];
  }, [game.gameState?.teams]);

  React.useEffect(() => {
    if (!selectedRecepient) {
      setSelectedRecepient(recepients[0]);
    }
  }, [selectedRecepient]);

  return (
    <ul className="list-group facilitator-border-none p-2">
      {recepients.map((recepient) => (
        <li
          className="list-group-item cursor-pointer"
          onClick={() => setSelectedRecepient(recepient)}>
          <small
            className={`${
              selectedRecepient?.code === recepient.code
                ? 'fw-bold text-dark'
                : 'text-dark'
            }`}>
            {recepient.name}
          </small>
        </li>
      ))}
    </ul>
  );
};
